import { render, staticRenderFns } from "./SocalLogin.vue?vue&type=template&id=00ccb786&scoped=true"
import script from "./SocalLogin.vue?vue&type=script&lang=js"
export * from "./SocalLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ccb786",
  null
  
)

export default component.exports